var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "portlet-title" }, [
      _c("div", { staticClass: "caption" }, [
        _c("i", { staticClass: "icon-equalizer font-red-sunglo" }),
        _vm._v(" "),
        _c(
          "span",
          { staticClass: "caption-subject font-red-sunglo bold uppercase" },
          [_vm._v(_vm._s(_vm.trans("menu_planner.title")))]
        )
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "portlet-body form" }, [
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col-sm-2" },
          [
            _c("date-picker", {
              attrs: { time: false },
              model: {
                value: _vm.menuPlanner.date,
                callback: function($$v) {
                  _vm.$set(_vm.menuPlanner, "date", $$v)
                },
                expression: "menuPlanner.date"
              }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col-sm-2" },
          [
            _c("div", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.brandsLoading,
                  expression: "brandsLoading"
                }
              ],
              staticClass:
                "glyphicon glyphicon-refresh glyphicon-refresh-animate loading-icon"
            }),
            _vm._v(" "),
            _c("singleselect", {
              attrs: {
                checked: _vm.menuPlanner.brand,
                name: "brand",
                title: "trans('menu_planner.entity.brand')",
                options: _vm.brands
              },
              on: {
                "option-selected": function($event) {
                  return _vm.getPackages($event.id)
                },
                remove: function($event) {
                  return _vm.clearPackages()
                }
              },
              model: {
                value: _vm.menuPlanner.brand,
                callback: function($$v) {
                  _vm.$set(_vm.menuPlanner, "brand", $$v)
                },
                expression: "menuPlanner.brand"
              }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col-sm-2" },
          [
            _c("div", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.packagesLoading,
                  expression: "packagesLoading"
                }
              ],
              staticClass:
                "glyphicon glyphicon-refresh glyphicon-refresh-animate loading-icon"
            }),
            _vm._v(" "),
            _c("singleselect", {
              attrs: {
                checked: _vm.menuPlanner.package,
                name: "package",
                title: "trans('menu_planner.entity.package')",
                options: _vm.packages
              },
              model: {
                value: _vm.menuPlanner.package,
                callback: function($$v) {
                  _vm.$set(_vm.menuPlanner, "package", $$v)
                },
                expression: "menuPlanner.package"
              }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col-sm-4" },
          [
            _c(
              "button",
              {
                staticClass: "btn btn-success margin-right-10",
                attrs: { type: "button" },
                on: {
                  click: function($event) {
                    return _vm.showMenu()
                  }
                }
              },
              [
                _c("span", {
                  staticClass: "glyphicon glyphicon-circle-arrow-right"
                }),
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.trans("menu_planner.generate")) +
                    "\n        "
                )
              ]
            ),
            _vm._v(" "),
            _vm.menuPlanner.brand
              ? _c("macronutrient-report", {
                  attrs: { brand: _vm.menuPlanner.brand, brands: _vm.brands }
                })
              : _vm._e()
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "col-sm-2" }, [
          _c("div", { staticClass: "margin-bottom-5" }, [
            _c(
              "button",
              {
                staticClass: "btn btn-success",
                attrs: {
                  id: "pdf",
                  disabled: !_vm.show,
                  "data-loading-text":
                    "<i class='fa fa-circle-o-notch fa-spin'></i> Proszę czekać",
                  type: "button"
                },
                on: {
                  click: function($event) {
                    return _vm.generatePdf()
                  }
                }
              },
              [
                _c("span", {
                  staticClass: "glyphicon glyphicon-align-justify"
                }),
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.trans("menu_planner.report_pdf")) +
                    "\n          "
                )
              ]
            )
          ]),
          _vm._v(" "),
          _c("div", [
            _c(
              "button",
              {
                staticClass: "btn btn-success",
                attrs: {
                  id: "pdf_28",
                  type: "button",
                  "data-loading-text":
                    "<i class='fa fa-circle-o-notch fa-spin'></i> Proszę czekać",
                  disabled: !_vm.show
                },
                on: {
                  click: function($event) {
                    return _vm.generatePdf(28)
                  }
                }
              },
              [
                _c("span", {
                  staticClass: "glyphicon glyphicon-align-justify"
                }),
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.trans("menu_planner.report_pdf_28_days")) +
                    "\n          "
                )
              ]
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _vm.isEditRoute && !_vm.isEditViewLoading
        ? _c("div", { staticClass: "row" }, [
            _c("hr"),
            _vm._v(" "),
            _vm.showCopyCalendarPicker
              ? _c(
                  "div",
                  { staticClass: "col-sm-2" },
                  [
                    _c("date-picker", {
                      attrs: { time: false },
                      model: {
                        value: _vm.copyFromDate,
                        callback: function($$v) {
                          _vm.copyFromDate = $$v
                        },
                        expression: "copyFromDate"
                      }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.showCopyCalendarPicker
              ? _c("div", { staticClass: "col-sm-4" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-success",
                      attrs: {
                        type: "button",
                        disabled: _vm.$store.state.dateDataIsLoading
                      },
                      on: {
                        click: function($event) {
                          return _vm.copyMenu()
                        }
                      }
                    },
                    [
                      _c("span", {
                        staticClass: "glyphicon glyphicon-circle-arrow-right"
                      }),
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.trans("menu_planner.copy")) +
                          "\n        "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _vm.showCopyMenuButton
                    ? _c(
                        "button",
                        {
                          staticClass: "btn btn-success",
                          attrs: {
                            type: "button",
                            disabled: _vm.$store.state.dateDataIsLoading
                          },
                          on: {
                            click: function($event) {
                              return _vm.copyMenuFromNtfy()
                            }
                          }
                        },
                        [
                          _c("span", {
                            staticClass:
                              "glyphicon glyphicon-circle-arrow-right"
                          }),
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.trans("menu_planner.copy_from_ntfy")) +
                              "\n        "
                          )
                        ]
                      )
                    : _vm._e()
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "col-sm-4" }, [
              _c(
                "button",
                {
                  staticClass: "btn btn-success",
                  attrs: { type: "button" },
                  on: {
                    click: function($event) {
                      return _vm.showCopyCalendar()
                    }
                  }
                },
                [
                  _c("span", {
                    staticClass: "glyphicon glyphicon-circle-arrow-right"
                  }),
                  _vm._v(
                    "\n          " +
                      _vm._s(
                        !_vm.showCopyCalendarPicker
                          ? _vm.trans("menu_planner.copy_from_day")
                          : _vm.trans("menu_planner.hide_copy_from_day")
                      ) +
                      "\n        "
                  )
                ]
              )
            ])
          ])
        : _vm._e()
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3ac7481e", { render: render, staticRenderFns: staticRenderFns })
  }
}